export const CalendarLayoutBrowserConstants = {
    shouldShowAgendaPaneAsOverlay: 1199,
    shouldShowDynamicWeekColumns: 1238,
    shouldShowLeftNavAsOverlay_SUBLIMITY: 1079,
    shouldShowLeftNavAsOverlay_MONTH: 1079,
    shouldShowLeftNavAsOverlay_WEEK: 865,
    shouldShowLeftNavAsOverlay_DAY: 554,
};

export const CalendarLayoutColumnConstants = {
    shouldShowFullDateName_MONTH: 96,
    shouldShowFullDateName_WEEK: 153,
    shouldShowWeekDayTemp_MONTH: 136,
    shouldShowWeekDayTemp_WEEK: 165,
    shouldShowWeatherIcon_MONTH: 58,
    shouldShowWeatherIcon_WEEK_SPLIT: 70,
    shouldShowWeatherIcon_WEEK_NONSPLIT: 112,
};

export const CalendarLayoutSplitViewConstants = {
    selectedCalendarMinWidth_DAY: 160,
    selectedCalendarMinWidth_WEEK: 560,
};

export const CalendarLayoutLeftPaneConstants = {
    /**
     * The default width of the expanded left pane
     */
    leftPaneDefaultWidth: 228,

    /**
     * The minimum width of the expanded left pane
     */
    leftPaneMinWidthWithWeekNumbers: 244,

    /**
     * The minimum width of the expanded left pane
     */
    leftPaneMinWidthWithoutWeekNumbers: 228,

    /**
     * The maximum width of the expanded left pane
     */
    leftPaneMaxWidth: 320,

    /**
     * The static width of the left rail (collapsed left pane)
     */
    leftRailStaticWidth: 48,
};
